<template>
  <form @submit.prevent="submit">
    <label>
      {{ i18n.t('/configuration/komnumber') }}
    </label>
    <br />
    <div class="input-panel">
      <form-input
        id="kom-number"
        v-model="komNumber"
        title="komNumber"
        placeholder="Komnummer"
        :show-label="false"
      />

      <app-button button-type="submit" :disabled="isLoading" data-qa="open-komNumber-code-button">
        <span v-if="!isLoading">
          {{ i18n.t('/change-order/actions/create-new-change-order') }}
        </span>
        <loader v-else />
      </app-button>
      <error-modal :errors="errors" title="Error"></error-modal>
    </div>
  </form>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import FormInput from '@/components/generic/presentational/atoms/formInput/FormInput.vue'
import ConfigurationHelper from '@/helpers/ConfigurationHelper'
import { EventBus } from '@/plugins/event-bus'
import changeOrderService from '@/services/changeOrderService'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import ErrorModal from '@/components/generic/presentational/atoms/errorModal/ErrorModal.vue'

export default {
  components: {
    Loader,
    AppButton,
    FormInput,
    ErrorModal,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      komNumber: '',
      isIncorrectKomNumber: false,
      isLoading: false,
      errors: null,
    }
  },
  methods: {
    async submit() {
      this.komNumber = this.komNumber.trim()
      if (!ConfigurationHelper.isValidKomNumber(this.komNumber)) {
        EventBus.$emit('notification-warning', 'Vul een juiste komnumber in')
        return
      }

      let changeOrder = await this.getChangeOrderByKomNumber()
      if (changeOrder === null || changeOrder?.ValidationMessages != null) {
        let genericResult = changeOrder?.ValidationMessages?.GenericResult
        EventBus.$emit('notification-warning', genericResult?.ErrorMessages.join('\n'))

        this.errors = genericResult?.ErrorMessages.join('\n')

        return
      }

      let params = {
        ...this.$route.params,
        komNumber: this.komNumber,
        komYear: changeOrder.KomYear,
      }

      this.$router.push({ name: 'new-change-order-page', params })
    },
    async getChangeOrderByKomNumber() {
      try {
        this.isLoading = true
        this.errors = null
        return await changeOrderService.getChangeOrderByKomNumber(this.komNumber)
      } catch (error) {
        let errorData = error?.response?.data

        // Check for new error format (Messages array)
        if (
          !!errorData?.Messages &&
          Array.isArray(errorData.Messages) &&
          errorData.Messages.length > 0
        ) {
          // Translate dictionary keys to actual messages
          const translatedMessages = errorData.Messages.map((msg) => {
            // Check if message is a dictionary key (starts with /)
            if (typeof msg === 'string' && msg.startsWith('/')) {
              // Translate with variables
              const translated = this.i18n.t(msg, errorData.Variables)
              return translated !== msg ? translated : msg
            }
            // Return message as-is if not a dictionary key
            return msg
          })

          return {
            ValidationMessages: {
              GenericResult: {
                ErrorMessages: translatedMessages,
              },
            },
          }
        }

        // Check for change order error format (ValidationMessages)
        if (!!errorData?.ValidationMessages) return errorData.ValidationMessages

        const errorMessage = this.composeErrorMessage(this.komNumber)

        return {
          ValidationMessages: {
            GenericResult: {
              ErrorMessages: [errorMessage],
            },
          },
        }
      } finally {
        this.isLoading = false
      }
    },
    composeErrorMessage(komNumber) {
      return `De change order met komnummer ${komNumber} werd niet gevonden.`
    },
  },
}
</script>

<style lang="scss" scoped>
.input-panel {
  display: flex;
  flex-flow: row wrap;

  #kom-number-container,
  #kom-year {
    margin-right: 10px;
    height: 45px;
  }
}

.komNumber-input {
  display: flex;
  flex-flow: row wrap;
}
</style>
